import ManageCard from 'features/cardManagement/screens/ManageCard/ManageCard';
import React from 'react';

export default function CardManagerPage() {
  return <ManageCard />;
}
